import API from '../AxiosInstance';

export default {
  getByPod: function(podId) {
    return API.get('pods/' + podId + '/authenticitychecks');
  },

  getLatestByPod: function(podId) {
    return API.get('pods/' + podId + '/authenticitychecks/latest');
  },

  getSummary: function(podId) {
    return API.get('pods/' + podId + '/authenticitychecks/summary');
  },
};
